import { useWeb3React } from '@web3-react/core'
import Big from 'big.js'
import { useContext } from 'react'

import { MetronomeContext } from '../components/MetronomeContext'

export const useValidation = function ({ balance = 0, limit = 0 }) {
  const { isActive: active } = useWeb3React()
  const { inputValue } = useContext(MetronomeContext)
  return {
    amountIsZero: Big(inputValue).eq(0),
    limitExceeded: Big(inputValue).gt(limit),
    notEnoughBalance: Big(inputValue).gt(balance),
    walletIsActive: active
  }
}
